<template>
  <svg width="24px" height="24px"
       viewBox="0 0 24 24" version="1.1"
       xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>atoms/icons/24x24/chevron/down/black</title>
    <g id="atoms/icons/24x24/chevron/down/black" stroke="none"
       stroke-width="1"
       fill-rule="evenodd">
      <path d="M18.639528,7.8586545 C19.0434435,7.4819972 19.6762228,7.50409434 20.0528801,7.90800984 C20.4295374,8.31192534 20.4074402,8.94470461 20.0035247,9.3213619 L12.6899877,16.1413455 C12.5183104,16.3014371 12.3052883,16.3894927 12.0881602,16.4068126 C12.083891,16.4054688 12.0802211,16.4058115 12.0765497,16.4061341 C12.0511765,16.4094153 12.0251359,16.4101898 11.9991094,16.4099545 C11.9722195,16.4102095 11.9458445,16.4094382 11.9195205,16.4076288 C11.9164521,16.4058103 11.9127679,16.4054661 11.9090854,16.4051015 C11.6913994,16.3894927 11.4783773,16.3014371 11.3067,16.1413455 L3.99316301,9.3213619 C3.58924751,8.94470461 3.56715037,8.31192534 3.94380767,7.90800984 C4.32046496,7.50409434 4.95324423,7.4819972 5.35715973,7.8586545 L11.9981576,14.0510044 Z" id="Combined-Shape"
      ></path>
    </g>
  </svg>
</template>
<script setup>
// dummy comment to surpress rollup build errors with dynamic imports
// if the file doesn't contain a script tag with content, the build fails.
</script>
